<template>
    <div class="c-html" v-html="html"></div>
</template>

<script>
  export default {
      name: 'Html',
      components: {
      },
      props: {
          html: {
              type: String,
              default: ''
          }
      },
      watch: {
      },
      mounted() {
      },
      data: () => {
          return {
          }
      },
      methods: {
      }
  }
</script>